module.exports = __webpack_public_path__ + "img/85_10.781e4cf6.png";